const RecognitionStatus = {
    PendingRecognizing: 1,
    OcrProcess: 2,
    InRecognitionQueue: 3,
    BeingRecognised: 4,
    Recognized: 5,
    NotRecognized: 6,
    PendingReview: 7,
    Validated: 8,
    Failed: 9,
    Deleted: 10,
    1: 'pendingRecognizing',
    2: 'ocrProcess',
    3: 'inRecognitionQueue',
    4: 'beingRecognised',
    5: 'recognized',
    6: 'notRecognized',
    7: 'pendingReview',
    8: 'validated',
    9: 'failed',
    10: 'deleted',
    pendingRecognizing: 1,
    ocrProcess: 2,
    inRecognitionQueue: 3,
    beingRecognised: 4,
    recognized: 5,
    notRecognized: 6,
    pendingReview: 7,
    validated: 8,
    failed: 9,
    deleted: 10
}
export default RecognitionStatus
